export const PAGE_NAME = {
    hall: 'hall',
    yourOrder: 'your-order',
    contactInfo: 'contact-info',
    orderSummary: 'order-summary',
}
